import $ from 'jquery'
export default {
    name: 'manage-traitement',
    components: {},
    props: {
        action_info: Object,
        single_action_info: Object,
        traitant_id: Number,
        soin_justif: String,
    },

    data() {
        return {
            all_checked: false,
            one_is_checked: [],
            required_field_is_empty: false,
            is_error: false,
            error_message: '',
            save_loading: false,

            justif_soin: '',
            can_do_action: true,
            list_medicaments: [],
            is_confirm: false,
        }
    },

    watch: {
        action_info() {
            this.clearError()
            this.checkIfCanDoAction()
        },

        single_action_info() {
            this.is_confirm = false
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        toutSelectionner() {
            this.clearError()
            let is_checked = $('#select-all').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                this.action_info.medicaments.forEach((el) => {
                    this.one_is_checked.push(el.soin_a_faire_id)
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false
            }
        },

        onOneChange() {
            this.clearError()
            document.getElementById("select-all").checked = false;
        },

        checkIfCanDoAction() {
            if (this.action_info.process_status == 1 || this.action_info.process_status == 4) {
                this.list_medicaments = this.action_info.medicaments.filter((el) => (el.etat_traitement == null || el.etat_traitement == 0))
            } else if (this.action_info.process_status == 2 || this.action_info.process_status == 3) {
                this.list_medicaments = this.action_info.medicaments.filter((el) => (el.etat_traitement == 1))
            }
            if (this.list_medicaments.length > 0) {
                this.can_do_action = true
            } else {
                this.can_do_action = false
            }
        },

        submit() {
            if (this.one_is_checked.length == 0) {
                this.required_field_is_empty = true
                return
            }

            if (this.action_info.process_status > 2 && this.justif_soin == '') {
                this.required_field_is_empty = true
                return
            }

            const data = {
                evolution_id: this.action_info.evolution_id,
                consultation_id: this.action_info.consultation_id,
                protocole_id: this.action_info.protocole_id,
                medicaments: this.one_is_checked,
                process_status: this.action_info.process_status,
                justif_soin: this.justif_soin,
                traitant_id: this.traitant_id
            }

            this.save_loading = true
            this.$store.dispatch('saveProcessStatus', data).then((response) => {
                if (response.success) {
                    this.successToast('Enregistrement effectué avec succès')
                    this.$emit('emitTraitement')

                    document.getElementById("select-all").checked = false;
                    this.one_is_checked = []
                    this.justif_soin = ''

                    this.$refs.mng_soins.click()
                } else {
                    this.is_error = true
                    if (response.code === 401) {
                        this.error_message = "Impossible d'effectuer cette opération !"
                    } else if (response.code === 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
                this.error_message = "Une erreur s'est produite !"
            })
        },

        clearError() {
            this.required_field_is_empty = false
            this.is_error = false
            this.error_message = "Une erreur s'est produite !"
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		/**
		 * Supprimer une CAT/Consigne
		 */
        submitAction(selector) {
            if (this.single_action_info.process_status > 2 && this.justif_soin == '') {
                this.required_field_is_empty = true
                return
            }

            const confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }


            this.save_loading = true
            console.log(this.single_action_info);

            const data = {
                evolution_id: this.single_action_info.evolution_id,
                consultation_id: this.single_action_info.consultation_id,
                protocole_id: this.single_action_info.protocole_id,
                traitant_id: this.traitant_id,
                process_status: this.single_action_info.process_status,
                medicaments: [this.single_action_info.medicament.soin_a_faire_id],
                justif_soin: this.justif_soin
            }
            console.log(data);

            this.$store.dispatch('saveProcessStatus', data).then((response) => {
                if (response.success) {
                    this.successToast('Enregistrement effectué avec succès')
                    this.$emit('emitTraitement')
                    this.justif_soin = ''

                    this.$refs.do_action.click()
                } else {
                    this.is_error = true
                    if (response.code === 401) {
                        this.error_message = "Impossible d'effectuer cette opération !"
                    } else if (response.code === 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                this.save_loading = false
                this.is_confirm = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
                this.error_message = "Une erreur s'est produite !"
            })
        },
    }
}